export const IP_URL = 'http://191.98.184.210:8080'
// export const IP_URL = 'http://191.98.184.211:8080'
export const BASE_IP_URL = IP_URL
export const BASE_URL = `${IP_URL}/lipapublication`